import React from 'react';

import PropTypes from 'prop-types';

import * as Style from './style';

import settings from '../../services/settings.json';

const Card = ({
	children,
	title,
	icon,
	padding,
	margin,
	height,
	width,
	position,
	noshadow,
	backgroundimage,
	background,
	bgcolor,
	display,
	justifyContent,
	align,
	heightDesktop,
}) => (
	<Style.Container
		role="region"
		margin={margin}
		height={height}
		width={width}
		position={position}
		noshadow={noshadow}
		backgroundimage={backgroundimage}
		background={background}
		bgcolor={bgcolor}
		heightDesktop={heightDesktop}
	>
		{
				title && (
					<Style.Title role="heading">
						{icon && (<span data-test="icon">{icon}</span>)}
						<h5 data-test="title">{title}</h5>
					</Style.Title>
				)
			}
		<Style.Content
			padding={padding}
			display={display}
			justifyContent={justifyContent}
			align={align}
		>
			{children}
		</Style.Content>
	</Style.Container>
	);

Card.defaultProps = {
	title: '',
	icon: null,
	padding: '32px',
	margin: '0',
	height: 'auto',
	width: '100%',
	position: 'relative',
	noshadow: false,
	backgroundimage: '',
	background: settings.color.light,
	bgcolor: settings.color.light,
	display: '',
	justifyContent: '',
	align: '',
	heightDesktop: '',
};

Card.propTypes = {
	background: PropTypes.string,
	children: PropTypes.isRequired,
	title: PropTypes.string,
	icon: PropTypes.element,
	padding: PropTypes.string,
	margin: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
	position: PropTypes.string,
	noshadow: PropTypes.bool,
	backgroundimage: PropTypes.string,
	bgcolor: PropTypes.string,
	display: PropTypes.string,
	justifyContent: PropTypes.string,
	align: PropTypes.string,
	heightDesktop: PropTypes.string,
};

export default Card;
